module.exports = __webpack_public_path__ + "img/vertical_4_3_7016.a6627277.png";